import { render, staticRenderFns } from "./bball-scores.vue?vue&type=template&id=409bd0ec&scoped=true"
import script from "./bball-scores.vue?vue&type=script&lang=js"
export * from "./bball-scores.vue?vue&type=script&lang=js"
import style0 from "./bball-scores.vue?vue&type=style&index=0&id=409bd0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bd0ec",
  null
  
)

export default component.exports